import React, { useState, useCallback } from 'react';
import { TextField, Button } from '@mui/material';

interface KeywordFormProps {
    onAddKeyword: (keyword: string) => void;
    placeholder: string;
    buttonLabel: string;
    infoMessage: string;
    setInfoMessage: (message: string) => void;
    title: string;
}

const KeywordForm: React.FC<KeywordFormProps> = ({ onAddKeyword, placeholder, buttonLabel, infoMessage, setInfoMessage, title }) => {
    const [newKeyword, setNewKeyword] = useState('');
    const [isComposing, setIsComposing] = useState(false);

    const handleAddKeyword = useCallback(() => {
        onAddKeyword(newKeyword);
        setNewKeyword('');
    }, [newKeyword, onAddKeyword]);

    const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setNewKeyword(e.target.value);
    }, []);

    const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !isComposing && !e.nativeEvent.isComposing && !e.shiftKey) {
            handleAddKeyword();
            e.preventDefault();
            e.stopPropagation();
        }
    }, [handleAddKeyword, isComposing]);

    const handleCompositionStart = useCallback(() => {
        setIsComposing(true);
    }, []);

    const handleCompositionEnd = useCallback(() => {
        setIsComposing(false);
    }, []);

    return (
        <div className='add-keyword'>
            <h3>{title}</h3>
            <div className='input-container'>
                <TextField
                    type="text"
                    label="キーワードを入力"
                    value={newKeyword}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onCompositionStart={handleCompositionStart}
                    onCompositionEnd={handleCompositionEnd}
                    variant="outlined"
                />
                <Button className='add-button' onClick={handleAddKeyword} variant='contained'>{buttonLabel}</Button>
            </div>
            <div className='add-message'>
                <p>{infoMessage}</p>
            </div>
        </div>
    );
};

export default KeywordForm;
